<template>
    <transition name="fade">

        <div class="player" name="ppPdfView" v-if="visible">
            <div class="pdf-content">
                <video v-if="videoPlayerLoaded && !inFrame" :src="src" id="player" controls allow="autoplay"></video>

                <div v-if="videoPlayerLoaded && inFrame" class="plyr__video-embed" id="player">
                    <iframe
                            :src="src"
                            allowfullscreen
                            allowtransparency
                            allow="autoplay"
                    ></iframe>
                </div>

            </div>
        </div>
    </transition>

</template>

<script>
    import UI from '../helpers/ui-helpers'
    import plyr from 'plyr'
    import plyrcss from '../../../node_modules/plyr/dist/plyr.css'

    let player;
    export default {
        name: "pdf-viewer",

        props: ['title', 'auto'],

        data(){
            return {
                src: null,
                numPages: null,
                currentPage: null,
                visible: false,
                isMobile: UI.check_mobile(),
                videoPlayerLoaded: false,
                inFrame: false,
                progress: 0,
                maxPage: 0
            }
        },

        watch: {
            visible(newVal){
                if(newVal === false){
                    player.destroy();
                    this.videoPlayerLoaded = false;
                }
            }
        },

        methods:{
            show(url, page, progressPage, inFrame) {
                let vm = this;

                console.info('show -> [vm.src, url]', [vm.src, url]);
                if(vm.src != url && player){
                    player.destroy();
                    this.videoPlayerLoaded = false;
                    console.info('destroyed')
                }

                vm.inFrame = inFrame || false;
                vm.visible = true;
                vm.src = url;

                if(progressPage){
                    this.maxPage = progressPage;
                }

                if(!this.videoPlayerLoaded) {
                    this.videoPlayerLoaded = true;

                    setTimeout(function () {
                        vm.$nextTick(() => {
                            vm.playerInit();

                            player.once('ready', event => {
                                console.info('go on from ', page);
                                player.currentTime = page;
                                if(vm.auto === true) {
                                    player.play();
                                }
                            });
                        });
                    }, 50);
                }
                else{
                    player.currentTime = page;
                    if(vm.auto === true) {
                        player.play();
                    }
                }
            },

            setContainerSize(){
                let $ppView = $('[name=ppPdfView]');
                let ppWidth = $ppView.width(),
                    ppHeight = $ppView.height();
                const scale = 16 / 9;

                if (ppWidth > ppHeight) {
                    if (ppHeight * scale > ppWidth)
                        ppHeight = (ppWidth / scale).toFixed(0)
                    $('[name=ppPdfView] > .pdf-content').height(ppHeight);
                    $('[name=ppPdfView] > .pdf-content').width(ppHeight * scale);
                }
                else{
                    $('[name=ppPdfView] > .pdf-content').width(ppWidth);
                }
            },

            playerInit(){
                console.info('player init')
                let vm = this;

                vm.setContainerSize();

                if(!vm.isMobile) {
                    //$('#player').css('max-height', $('#playContent').height());
                }
                // let sources = [
                //     {
                //         src: vm.src,
                //         type: 'video/mp4'
                //     }
                // ];
                // if(vm.inFrame){
                //     sources = [
                //         {
                //             src: vm.src.replace('https://youtube.com/embed/', ''),
                //             provider: 'youtube'
                //         }
                //     ];
                // }
                // console.info('sources', sources)

                player = new plyr('#player', {
                    ratio: '16:9',
                    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'fullscreen']
                });
                // player.source = {
                //     type: 'video',
                //     sources: sources
                // };

                player.once('ended', event => {
                    //console.info(`ended at ${Math.ceil(player.currentTime)}sec!`);
                    clearInterval(playerInterval);
                    //console.info('ended')
                    vm.$emit('onPageChanged', Math.ceil(player.currentTime), Math.ceil(player.currentTime),);
                });

                player.on('seeking', e => {
                    if (player.currentTime > vm.maxPage) {
                        player.currentTime = vm.maxPage;
                    }
                });

                //console.info('setting interval')
                let playerInterval = setInterval(function(){
                    if(player.playing){
                        //console.info(`playing on ${Math.ceil(player.currentTime)}sec`);
                        vm.$emit('onPageChanged', Math.ceil(player.currentTime), Math.ceil(player.duration));
                        vm.progress = Math.max(vm.progress, Math.ceil(player.currentTime)  / Math.ceil(player.duration));
                        vm.maxPage = Math.max(vm.maxPage,Math.ceil(player.currentTime));
                    }
                }, 1000);
            },
        },

        mounted () {
            let vm = this;
            $(window).on('resize orientationchange', function () {
                if(vm.visible) {
                    vm.setContainerSize();
                }
            });
        },

        destroyed(){
            $(window).off('resize orientationchange');
        }
    }
</script>

<style>
    .pagefade-enter-active, .pagefade-leave-active {
        transition: opacity 0.2s;
    }
    .pagefade-enter, .pagefade-leave-to {
        opacity: 0;
    }

    .pagefade{
        background: #fff;
        height: 100%;
        width: 100%;
        position: absolute;
        opacity: 0.5;
    }

    .plyr__video-embed iframe {
        top: -50%;
        height: 200%;
    }
</style>


// WEBPACK FOOTER //
// Content/src/components/VideoViewer.vue